import React from "react";

export const ArchiveIcon: React.FC<React.SVGProps<SVGSVGElement>> = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M4.22626 18.5224C3.70149 18.5224 3.25433 18.3377 2.88476 17.9681C2.51519 17.5985 2.3304 17.1514 2.3304 16.6266V7.27969C2.09429 7.11799 1.89638 6.91217 1.73665 6.66226C1.57693 6.41234 1.49707 6.10608 1.49707 5.74347V3.39292C1.49707 2.86816 1.68186 2.42099 2.05145 2.05142C2.421 1.68185 2.86816 1.49707 3.39292 1.49707H16.6067C17.1314 1.49707 17.5786 1.68185 17.9482 2.05142C18.3177 2.42099 18.5025 2.86816 18.5025 3.39292V5.74347C18.5025 6.10608 18.4227 6.41234 18.2629 6.66226C18.1032 6.91217 17.9053 7.11799 17.6692 7.27969V16.6266C17.6692 17.1514 17.4844 17.5985 17.1148 17.9681C16.7453 18.3377 16.2981 18.5224 15.7733 18.5224H4.22626ZM16.6067 5.74347V3.39292H3.39292V5.74347H16.6067ZM8.27834 11.7263H11.7213C11.9673 11.7263 12.1735 11.643 12.3399 11.4766C12.5063 11.3102 12.5895 11.104 12.5895 10.858C12.5895 10.6119 12.5063 10.4049 12.3399 10.2369C12.1735 10.0689 11.9673 9.98486 11.7213 9.98486H8.27834C8.03234 9.98486 7.82614 10.0685 7.65974 10.2359C7.49333 10.4033 7.41013 10.6106 7.41013 10.858C7.41013 11.104 7.49333 11.3102 7.65974 11.4766C7.82614 11.643 8.03234 11.7263 8.27834 11.7263Z"
      fill="#767676"
    />
  </svg>
);
